import React from 'react';
import PropTypes from 'prop-types';

// function to format vanity numbers
import highlightCustomTollFreeNumbers from '~/common/utils/highlightCustomTollFreeNumbers.js';
import highlightCustomTollFreeLetters from '~/common/utils/highlightCustomTollFreeLetters.js';

// Import Icon
import phoneIcon from '~/common/images/phone-icon-black.svg';
import checkIcon from '~/common/images/gh-green-check.svg';

// Import Local Styles
import styles from './select-number-button.css';

const SelectNumberButton = (props) => {
    const { selected, term, onClick, vanity, number } = props;
    return (!!number.UI &&
        <a
            className={`${
                styles.wrapper} ${
                vanity ? styles['wrapper--vanity'] : ''} ${
                selected ? styles['wrapper--selected'] : ''
            }`}
            id="number-select__button"
            onClick={onClick}
            role="button"
            tabIndex="0"
        >
            <img className={styles.image} src={selected ? checkIcon : phoneIcon} ></img>
            {vanity ?
                <div className={styles['text-group']}>
                    <span className={`${styles.text} ${styles['text--letters']}`}>
                        {highlightCustomTollFreeLetters(number.UI, term)}
                    </span>
                    <span className={styles.text}>
                        {highlightCustomTollFreeNumbers(number.UI, term)}
                    </span>
                </div>
                :
                <span className={styles.text}>
                    {number.UI}
                </span>
            }
        </a>
    );
};

SelectNumberButton.propTypes = {
    onClick: PropTypes.func,
    number: PropTypes.object.isRequired,
    selected: PropTypes.bool,
    term: PropTypes.string,
    vanity: PropTypes.bool
};

SelectNumberButton.defaultProps = {
    vanity: false
};

export default SelectNumberButton;
